//@flow
import React from 'react';
import { connect } from 'react-redux';
import * as Redux from 'redux';
import styled from 'styled-components';
import ReactSVG from 'react-svg';
import { loadResourcesDetails } from '../../../../actions/resource';
import { modalInstance } from '../../../../containers/content/Content';
import MenuIcon from '../../../../icons/menu.svg';
import { translate } from "react-i18next";
import DropdownMenu from '../../../../components/DropdownMenu';
import { getFlights } from '../../../../actions/flightManager';
import messageManager from '../../../../utilities/messageManager';

const StyledLabel = styled.label`
	display: flex;
	align-items: center;
	justify-content: space-between;
	margin: 5px 0;
	color: #2d2d2d;
	font-size: 13px;
	font-weight: 600;
	>input{
		height: 20px;
		width: 20px;
	}
`;

const DropDownListRow = styled.div`
	pointer-events: ${props => props.disabled ? 'none' : 'all'};
	background-color: ${props => props.disabled ? 'rgba(255, 255, 255, 0.5)' : 'transparent'};
`;

const StyledSpinner = styled.div`
	margin-left: auto;
	margin-top: 3px;
	margin-right: 3px;
	border-top: 3px solid #265a9c50;
	border-right: 3px solid #265a9c50;
	border-bottom: 3px solid #265a9c50;
	border-left: 3px solid #265a9c;
	animation: animation 1.1s infinite linear;
	border-radius: 50%;
	width: 12px;
	height: 12px;

  @keyframes animation {
	0% {
		transform: rotate(0deg);
	}
	100% {
		transform: rotate(360deg);
	}
}
`;

type ResourceLabelProps = {
	resource: Object,
	axiosInstance: Object,
	t: Object
};

type ResourceLabelState = {
	menuVisible: boolean,
	spinnerVisible: boolean
};

export class ResourceLabel extends React.Component<ResourceLabelProps, ResourceLabelState> {
	constructor() {
		super();
		this.state = {
			menuVisible: false,
			spinnerVisible: false
		};
		this.setWrapperRef = this.setWrapperRef.bind(this);
		this.handleClick = this.handleClick.bind(this);
	}

	deleteResource() {
		const { BASE_URL, t, resource, axiosInstance, loadResourcesDetails, getFlights } = this.props;
		const confirmCallback = () => {
			axiosInstance.delete(`${BASE_URL}/resources/${resource.id}`)
				.then((response) => {
					this.setState({ spinnerVisible: false });
					getFlights(axiosInstance);
					loadResourcesDetails(axiosInstance, resource.projectId);                   
					messageManager.show({
						type: 'info',
						text: t('Attachment deleted'),
					});
				})
				.catch(error => {
					messageManager.show({
						type: 'error',
						text: t(error.response.data ? error.response.data : t('Error occured while deleting attachment')),
					});
				});
		}
		const cancelCallback = () => {
			this.setState({ spinnerVisible: false });
		}
		const config = {
			title: t('Do you really want to delete resource') + '?',
			content: <p>{t('Do you really want to delete resource')} <b>{String(resource.fileName)}</b>?</p>,
			confirmCallback: confirmCallback,
			cancelCallback: cancelCallback,
			cancelBtnVisible: true,
			confirmBtnVisible: true,
			confirmBtnText: t('Delete'),
			closeOnConfirm: true,
			type: 'warning',
		}
		modalInstance.customize(config);
		modalInstance.show();
	}

	downloadResourceFiles(): void {
		const { BASE_URL } = this.props;
		this.setState({ spinnerVisible: false, });
		const token = localStorage.getItem('token');
		const src = `${BASE_URL}/resources/${this.props.resource.id}/download?token=${token}`;
		window.location.href = src;
	}

	// source: https://stackoverflow.com/questions/32553158/detect-click-outside-react-component
	setWrapperRef(node) {
		this.wrapperRef = node;
	}

	handleClick(event) {
		document.removeEventListener('mousedown', this.handleClick);
		if (this.wrapperRef && this.wrapperRef.contains(event.target)) {
			this.setState({
				spinnerVisible: true,
				menuVisible: false,
			});
			const parentId = event.target.id || event.target.parentNode.id;
			switch(parentId) {
				case 'Delete':
					this.deleteResource();
					break;
				case 'DownloadFiles':
					this.downloadResourceFiles();
					break;
				default:
					this.setState({ spinnerVisible: false });
					break;
			}
		} else {
			this.setState({ menuVisible: false });
		}
	}

	render(): React.Node {
		const { t, roles } = this.props;
		return (
			<StyledLabel>
				{true
					? this.state.spinnerVisible
						? <StyledSpinner/>
						: <div
							style={{
								cursor: 'pointer',
								marginLeft: 'auto',
								marginTop: '3px',
								marginRight: '3px'
							}}
							onClick={() => {
								document.addEventListener('mousedown', this.handleClick);
								this.setState({ menuVisible: !this.state.menuVisible });
							}}>
							<ReactSVG
								path={MenuIcon}
								style={{
									fill: '#215597',
									width: '20px',
									height: '20px',
									display: 'flex',
									alignItems: 'center',
								}}
							/>
						</div>
					: null}
				<div ref={this.setWrapperRef}
					style={{
						display: this.state.menuVisible ? 'flex' : 'none',
						position: 'relative',
					}}
				>
					<DropdownMenu
						style={{
							top: '10px',
							right: '0px',
							width: '100px',
							zIndex: 15,
						}}
						menuVisible={this.state.menuVisible}
					>
						{roles === 'Regular' ? null : <DropDownListRow
							id='Delete'
							disabled={!true}
							title={t('Delete resource')}
						> 
							<span>{t('Delete resource')}</span>
						</DropDownListRow>}
						<DropDownListRow
							id='DownloadFiles'
							title={t('Download file')}
						>
							<span>{t('Download file')}</span>
						</DropDownListRow>
					</DropdownMenu>
				</div>
			</StyledLabel>
		);
	}
};

const mapStateToProps = state => ({
	axiosInstance: state.auth.get('axiosInstance'),
	roles: state.auth.get('roles'),
	BASE_URL: state.domainProperties.get('BASE_URL'),
});

const mapDispatchToProps = dispatch => Redux.bindActionCreators({
	loadResourcesDetails,
	getFlights
}, dispatch);

export default translate("translations")(connect(mapStateToProps, mapDispatchToProps)(ResourceLabel));


// WEBPACK FOOTER //
// ./src/containers/content/rightPanelContent/resourceLabel/ResourceLabel.jsx